import { render, staticRenderFns } from "./SemenCollectionEdit.vue?vue&type=template&id=f46874e8&scoped=true&"
import script from "./SemenCollectionEdit.vue?vue&type=script&lang=js&"
export * from "./SemenCollectionEdit.vue?vue&type=script&lang=js&"
import style0 from "./SemenCollectionEdit.vue?vue&type=style&index=0&id=f46874e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46874e8",
  null
  
)

export default component.exports